import React from 'react';

const ArrowDown: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M12.6663 6L7.99967 10.6667L3.33301 6" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
  </>
);

export default ArrowDown;
